import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DropdownFlat from '../Components/DropdownFlat'
import { connect } from 'react-redux'
import { getAllInspectorswithTypes, getInspectorAllocationsByInspectorId, GetInspectorAllocationsByInspectorIdWithRange, getInspectionDetailsByInspectorID, postAssignInspector, getInspectionDetailsByCallID, getCallsWithCallLineItems } from '../store/actions/inspectionActions'
import { Table, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import AuthHandlerInstance from '../Classes/AuthHandler'
import swal from '@sweetalert/with-react'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import Loading from '../Components/Loader';


function formatedDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}


class Allocateinspector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            polineitemId: this.props.location.state.polineitemId,
            poItemNo: this.props.location.state.poItemNo,
            callNo: this.props.location.state.callNo,
            callId: this.props.location.state.callId,
            InspectionId: this.props.location.state.InspectionId,
            inspector: [],
            comments: '',
            opacity: "",
            selectedFromTypeDropdown: 1,
            inspectorID: '',
            inspectorName: '',
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            calenderui: false,
            modal: false,
            allocatedModal: false,
            allocatedDetail: null,
            allocatedInspectionDate: '',
            inspectionStartDate: '',
            inspectionEndDate: '',
            inspectionInstruction: '',
            allocatedinspectionIndex: 0,
            callList: false,
            selectedCalls: [],
            call: '',
            inspectionDetailsByCallID: [],
            sameLocationCalls: [],
            checkedAll: false,
            loading: true,
            array: [
                { value: 1, label: "element1" },
                { value: 2, label: "element2" },
                { value: 3, label: "element3" },
                { value: 4, label: "element4" }],
        }
        this.modal = this.modal.bind(this);
        this.allocatedmodal = this.allocatedmodal.bind(this);
        this.inspectionInstruction = this.inspectionInstruction.bind(this);
        this.handleInspectionStartDate = this.handleInspectionStartDate.bind(this);
        this.handleInspectionEndDate = this.handleInspectionEndDate.bind(this);
        this.allocateinspector = this.allocateinspector.bind(this);
        this.toggleAllocateinspectorPopup = this.toggleAllocateinspectorPopup.bind(this);

    }

    modal(date) {
        //console.log(date,this.state.month,this.state.year)
        //this.props.parentModal()
        var allocatedInspectionDate = this.state.year + '/' + this.state.month + '/' + date
        //console.log(allocatedInspectionDate)
        this.setState({ modal: !this.state.modal });
        if (this.state.modal == true) {
            this.setState({ opacity: "", allocatedInspectionDate: '', inspectionInstruction: '' })

        } else {
            this.setState({ opacity: "0.2", allocatedInspectionDate })

        }
    }

    allocatedmodal(data) {
        // this.setState({ allocatedModal: !this.state.allocatedModal });
        this.setState({ allocatedDetail: data.inspectionDetail })
        this.setState({ allocatedinspectionIndex: 0 });
    }

    allocateinspector = async () => {
        let UserId = AuthHandlerInstance.getUserID()
        let errorMessage = '';
        if (this.state.inspectionEndDate === '') {
            errorMessage = `Please select End date first`
        }
        if (this.state.inspectionStartDate === '') {
            errorMessage = `Please select Start date first`
        }
        if (this.state.inspectorID === '') {
            errorMessage = `Please select Inspector`
        }
        let selectedCalls = this.state.selectedCalls
        if (selectedCalls.length === 0) {
            errorMessage = `Please select a call`
        }
        if (errorMessage !== '') {
            swal(errorMessage, { icon: "error" })
            return false;
        }
        let call = await this.state.inspectionDetailsByCallID[0]
        console.log(call, 'callcallcallcallcall')
        var data = {
            UserId:UserId,
            Calls: this.state.selectedCalls,
            vendorId: call.VendorID,
            poId: call.lineItems[0].PurchaseOrderId,
            inspectorId: this.state.inspectorID,
            inpectorTypeId: this.state.selectedFromTypeDropdown,
            location: call.Location ? call.Location : call.lineItems[0].RequestedLocation ? call.lineItems[0].RequestedLocation : call.lineItems[0].VendorLocation,
            status:call.InspectionStatus === 'Inspector Allocated' ? 'Inspector Re-Allocated' : call.InspectionStatus !== 'Inspection Request Rejected' ? 'Inspector Allocated' : 'Inspector Re-Allocated',
            QAPlannerId: AuthHandlerInstance.getUserPayLoad().userId,
            fromDate: this.state.inspectionStartDate,
            toDate: this.state.inspectionEndDate,
            comments: this.state.comments,
            inspectionId: call.InspectionId
        }
        // console.log(data, call,'calldata')
        // return false;
        if (call.InspectionId && call.InspectionStatus !== 'Inspection Request Rejected') {
            await this.props.postAssignInspector(call.InspectionId, data)
        } else {
            await this.props.postAssignInspector('', data)
        }
        await this.props.history.goBack()
        console.log(data)
        // await this.props.postAssignInspector(data)
        // await this.modal()
        // await this.getInspectorallocation(this.state.inspectorID, this.state.year, this.state.month)
        // await this.props.getInspectionDetailsByCallID(this.state.callNo, this.state.polineitemId)
        // window.location.reload();

    }

    inspectionInstruction(event) { this.setState({ inspectionInstruction: event.target.value }) }



    getInspectorallocation(inspectorID, year, month) {
        this.props.getInspectorAllocationsByInspectorId(inspectorID, year, month)
        //this.props.getInspectorAllocationsByInspectorId(3,2021,1)
    }
    getInspectorallocationWithRange(inspectorID, year, month, startDate, endDate) {
        this.props.GetInspectorAllocationsByInspectorIdWithRange(inspectorID, year, month, startDate, endDate)
        //this.props.getInspectorAllocationsByInspectorId(3,2021,1)
    }

    dataSync = async () => {
        await this.props.getAllInspectorswithTypes()
        // await this.props.getInspectionDetailsByInspectorID(0)
        await this.props.getCallsWithCallLineItems({
            CallId: this.state.callId,
            InspectionId: this.state.InspectionId,
        })
        let selectedCalls = this.state.selectedCalls
        await selectedCalls.push(this.state.callId)

        let inspectionDetailsByCallID = []
        let sameLocationCalls = []
        let allInspectorswithTypes = await this.props.allinspectorswithtypes.allinspectorswithtypes
        let inspectionDetailsByInspectorId = await this.props.allinspectorswithtypes.allCalls
        console.log(inspectionDetailsByInspectorId, 'inspectionDetailsByInspectorId')

        if (inspectionDetailsByInspectorId) {
            inspectionDetailsByCallID = await inspectionDetailsByInspectorId.calls
            sameLocationCalls = await inspectionDetailsByInspectorId.sameLocationCalls
            let comments = ''
            let inspectorID = ''
            let inspectionStartDate = ''
            let inspectionEndDate = ''
            let selectedFromTypeDropdown = 1
            
            for (let i = 0; i < allInspectorswithTypes.length; i++) {
                const element = allInspectorswithTypes[i];
                if (element.inspectorTypeId == selectedFromTypeDropdown) {
                    await this.setState({ inspector: element.inspectors })
                }
            }

            if (inspectionDetailsByInspectorId.inspection) {
                var inspection = await inspectionDetailsByInspectorId.inspection
                inspectionStartDate = await formatedDate(inspection.FromDate)
                inspectionEndDate = await formatedDate(inspection.ToDate)
                selectedFromTypeDropdown = await inspection.InspectorTypeId
                inspectorID = await inspection.InspectorId
                comments = await inspection.Comments

                for (let i = 0; i < allInspectorswithTypes.length; i++) {
                    const element = allInspectorswithTypes[i];
                    if (element.inspectorTypeId == selectedFromTypeDropdown) {
                        await this.setState({ inspector: element.inspectors })
                    }
                }

                await this.getInspectorallocation(inspectorID, this.state.year, this.state.month)
            }
            await this.setState({
                inspectionStartDate: inspectionStartDate, inspectionEndDate: inspectionEndDate, inspectorID: inspectorID, selectedFromTypeDropdown: selectedFromTypeDropdown, inspectionDetailsByCallID, sameLocationCalls, calenderui: true, comments: comments, loading: false
            })

        }
        // for (let i = 0; i < inspectionDetailsByInspectorId.length; i++) {
        //     await inspectionDetailsByCallID.push(inspectionDetailsByInspectorId[i])

        // }

        // let selectedCalls = this.state.selectedCalls

        // let call = await this.props.allinspectorswithtypes && this.props.allinspectorswithtypes.allCalls && this.props.allinspectorswithtypes.allCalls.find((item) => item.callId === this.props.location.state.callId)
        // console.log(call, 'call11')
        // if (call && call.InspectionId && call.InspectionStatus !== 'Inspection Request Rejected') {
        //     let inspectionStartDate = formatedDate(call.InspectionStartDate)
        //     let inspectionEndDate = formatedDate(call.InspectionEndDate)
        //     let selectedFromTypeDropdown = call.InspectorTypeId
        //     let inspectorID = call.InspectorId
        //     let comments = call.Comments

        //     await this.props.allinspectorswithtypes.allCalls.map((item, Index) => {
        //         if (item.InspectionId && item.InspectionId == call.InspectionId) {
        //             selectedCalls.push(item.callId)
        //         }
        //     })

        //     await this.props.allinspectorswithtypes.allinspectorswithtypes.map((data, index) => {
        //         if (data.inspectorTypeId == call.InspectorTypeId) {
        //             this.setState({ inspector: data.inspectors })
        //         }
        //     })

        //     await this.getInspectorallocation(inspectorID, this.state.year, this.state.month)

        //     await this.setState({
        //         inspectionStartDate: inspectionStartDate, inspectionEndDate: inspectionEndDate, inspectorID: inspectorID, selectedFromTypeDropdown: selectedFromTypeDropdown, calenderui: true, comments: comments
        //     })
        // } else {
        //     await this.props.allinspectorswithtypes.allinspectorswithtypes.map((data, index) => {
        //         if (data.inspectorTypeId == 1) {
        //             this.setState({ inspector: data.inspectors })
        //         }
        //     })
        //     selectedCalls.push(this.props.location.state.callId)
        // }
        // this.setState({
        //     selectedCalls, call, inspectionDetailsByCallID, loading: false
        // })
    }

    componentDidMount = async () => {
        var userId = AuthHandlerInstance.getUserID()
        await this.dataSync()
    }

    changeMonth(direction) {
        var inspectorID = this.state.inspectorID
        var year = this.state.year
        var month = this.state.month + direction
        if (month == 0) {
            month = 12
            year = year - 1
        } else if (month == 13) {
            month = 1
            year = year + 1
        }
        this.setState({ month, year })
        this.getInspectorallocation(inspectorID, year, month)
        this.setState({ allocatedDetail: null })
    }

    handleType = (e) => {

        this.props.allinspectorswithtypes.allinspectorswithtypes.map((data, index) => {
            if (data.inspectorTypeId == e.target.value) {
                this.setState({ inspector: data.inspectors, inspectorID: '' })
            }
        })
        this.setState({
            selectedFromTypeDropdown: e.target.value,
        })

        var inspectorID = this.state.inspectorID
        if (inspectorID != '') {
            this.getInspectorallocation(inspectorID, this.state.year, this.state.month)
            this.setState({ allocatedDetail: null })
        }
    }

    handleInspector = async (e) => {
        var inspectorName = e.target.value
        var inspectorID
        await this.state.inspector.map((value, index) => {
            if (value.inspector_id == inspectorName) {
                inspectorID = value.inspector_id
                this.setState({
                    inspectorID, inspectorName
                })
            }
        })
        await this.getInspectorallocation(inspectorID, this.state.year, this.state.month)
        await this.setState({ allocatedDetail: null })
        await this.setState({ calenderui: true })
    }

    // ? func to add inspection date
    handleInspectionStartDate = (e) => {
        let inspectionStartDate = e.target.value

        this.setState({
            inspectionStartDate: inspectionStartDate,
            inspectionEndDate: inspectionStartDate
        })
    }

    handleInspectionEndDate = (e, value) => {
        let inspectionEndDate = e.target.value

        this.setState({
            inspectionEndDate: inspectionEndDate
        })

        // this.getInspectorallocationWithRange(this.state.inspectorID, this.state.year, this.state.month, this.state.inspectionStartDate, this.state.inspectionEndDate)
    }

    fun_month(i) {
        var month = new Array();

        month[1] = "January"; month[2] = "February"; month[3] = "March";
        month[4] = "April"; month[5] = "May"; month[6] = "June";
        month[7] = "July"; month[8] = "August"; month[9] = "September";
        month[10] = "October"; month[11] = "November"; month[12] = "December";

        return month[i]
    };

    toggleCalls = () => {
        let callList = !this.state.callList

        this.setState({ callList })
    }

    handleCheckedAll = async () => {
        let selectedCalls = [...this.state.selectedCalls]

        var checkedAll = !this.state.checkedAll

        await this.state.sameLocationCalls.map((item, Index) => {
            var flag_index = selectedCalls.includes(item.CallID)
            if (checkedAll) {
                if (!flag_index) {
                    selectedCalls.push(item.CallID)
                }
            } else {
                if (flag_index) {
                    selectedCalls = selectedCalls.filter((value) => value !== item.CallID)
                }
            }
        })

        this.setState({ selectedCalls, checkedAll })
    }

    handleCheck = (e, callId) => {
        let selectedCalls = [...this.state.selectedCalls]

        var flag_index = selectedCalls.includes(callId)
        var checkedAll = this.state.checkedAll
        if (flag_index) {
            if (checkedAll) {
                checkedAll = !checkedAll
            }
            selectedCalls = selectedCalls.filter((item) => item !== callId)
        } else {
            selectedCalls.push(callId)
        }
        this.setState({ selectedCalls, checkedAll })
    }

    toggleAllocateinspectorPopup() {
        let errorMessage = '';
        if (this.state.inspectionStartDate === '') {
            errorMessage = `Please select Start date first`
            swal(errorMessage, { icon: "error" })
            return false;
        }
        if (this.state.inspectionEndDate === '') {
            errorMessage = `Please select End date first`
            swal(errorMessage, { icon: "error" })
            return false;
        }
        this.setState({ modal: !this.state.modal });
        this.setState({ opacity: "0.2", allocatedInspectionDate: '' })
    }

    changeAllocatedInspection(index) {
        this.setState({ allocatedinspectionIndex: index });
    }

    handleChangeComment = async (e) => {
        await this.setState({ comments: e.target.value })
    }

    render() {
        console.log(this.state.selectedFromTypeDropdown, 'startDate')

        let typeObject = {}, typearray = []

        this.props.allinspectorswithtypes && this.props.allinspectorswithtypes.allinspectorswithtypes && this.props.allinspectorswithtypes.allinspectorswithtypes.map((data) => {
            typeObject = {
                id: data.inspectorTypeId,
                name: data.inpectorTypeName
            }
            typearray.push(typeObject)
        })

        console.log(this.props.allinspectorswithtypes)
        // var inspectionDetailsByCallID = []


        // console.log(inspectionDetailsByCallID, 'calendar')
        if (this.state.loading) {
            return (
                <Loading />
            )

        } else {

            //this.props.allinspectorswithtypes.inspectorallocation &&
            return (

                <div className="Container-fluid p-4">
                    {this.state.inspectionDetailsByCallID.length && this.state.inspectionDetailsByCallID.map((value, index) => (
                        <Modal isOpen={this.state.modal}>

                            <ModalHeader HeaderStyle="modalheaderWide modal-header">
                                <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Allocate Inspector</h4>
                                <button type="button" className="close" aria-label="Close" onClick={this.modal} style={{ color: 'black' }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>


                            <ModalBody Style="modal-body modalbodysWide">
                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>PO No : </b></div>
                                            <div className="col">{value.POSAPId}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Item No : </b></div>
                                            <div className="col">{value.POLineItemSAPCode}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>PO Date : </b></div>
                                            <div className="col">{dateFormater(value.POCreationDate)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Item Delivery Date : </b></div>
                                            <div className="col">{dateFormater(value.PODeliveryDate)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Supplier Name : </b></div>
                                            <div className="col">{value.VendorName}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Inspection Call No : </b></div>
                                            <div className="col">{value.InspectionCallNo}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>PO Quantity : </b></div>
                                            <div className="col">{value.POLineItemQuantity + " " + value.OrderUnit}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Quantity to Inspect : </b></div>
                                            <div className="col">{value.InspectionQuantity + " " + value.OrderUnit}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Location : </b></div>
                                            <div className="col">{value.Location}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Proposed Inspection Date : </b></div>
                                            <div className="col">{dateFormater(value.VendorProposedDate)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Stage to inspect : </b></div>
                                            <div className="col">{value.StageName}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col "><b>Status : </b></div>
                                            <div className="col">{value.Status}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Item Description : </b></div>
                                            <div className="col"> {value.POLineItemDescription} </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col "><b>Inspector Name : </b></div>
                                            <div className="col"> {value.InspectorName}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col "><b>Allocated Inspection Date : </b></div>
                                            <div className="col">{dateFormater(this.state.inspectionStartDate) + ' - ' + dateFormater(this.state.inspectionEndDate)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col "><b>Instructions for Inspector (If Any) : </b></div>
                                            <div className="col">
                                                <textarea className="form-control" type='text' rows="2" value={this.state.inspectionInstruction} onChange={this.inspectionInstruction}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </ModalBody>




                            <ModalFooter FooterStyle="modal-footer modalfooterWide">
                                <div>
                                    <button
                                        type="button"
                                        className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-left"
                                        onClick={() => this.allocateinspector(value.InspectionCallLineItemId)}
                                    >
                                        Allocate Inspector
                                    </button>
                                    <button
                                        type="button"
                                        className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right"
                                        onClick={this.modal.bind(this)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    ))}
                    <Modal isOpen={this.state.allocatedModal}>

                        <ModalHeader HeaderStyle="modalheaderWide modal-header">
                            <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Allocated Detail</h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.allocatedmodal} style={{ color: 'black' }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>

                        {this.state.allocatedDetail ?
                            <ModalBody Style="modal-body modalbodysWide">
                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>PO No : </b></div>
                                            <div className="col">{this.state.allocatedDetail.POSAPId}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Item No : </b></div>
                                            <div className="col">{this.state.allocatedDetail.POLineItemSAPCode}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>PO Date : </b></div>
                                            <div className="col">{dateFormater(this.state.allocatedDetail.POCreationDate)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Item Delivery Date : </b></div>
                                            <div className="col">{dateFormater(this.state.allocatedDetail.PODeliveryDate)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Supplier Name : </b></div>
                                            <div className="col">{this.state.allocatedDetail.VendorName}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Inspection Call No : </b></div>
                                            <div className="col">{this.state.allocatedDetail.InspectionCallNo}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>PO Quantity : </b></div>
                                            <div className="col">{this.state.allocatedDetail.POLineItemQuantity + " " + this.state.allocatedDetail.OrderUnit}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Quantity to Inspect : </b></div>
                                            <div className="col">{this.state.allocatedDetail.InspectionQuantity + " " + this.state.allocatedDetail.OrderUnit}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Location : </b></div>
                                            <div className="col">{this.state.allocatedDetail.Location}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Proposed Inspection Date : </b></div>
                                            <div className="col">{dateFormater(this.state.allocatedDetail.VendorProposedDate)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Stage to inspect : </b></div>
                                            <div className="col">{this.state.allocatedDetail.StageName}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col "><b>Status : </b></div>
                                            <div className="col">{this.state.allocatedDetail.Status}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col"><b>Item Description : </b></div>
                                            <div className="col"> {this.state.allocatedDetail.POLineItemDescription} </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col "><b>Inspector Name : </b></div>
                                            <div className="col"> {this.state.allocatedDetail.InspectorName}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col "><b>Allocated Inspection Date : </b></div>
                                            <div className="col">{dateFormater(this.state.allocatedDetail.inspectionStartDate) + ' - ' + dateFormater(this.state.allocatedDetail.inspectionEndDate)}</div>
                                        </div>
                                    </div>
                                </div>

                            </ModalBody>
                            : ''}



                        <ModalFooter FooterStyle="modal-footer modalfooterWide">
                            <div>
                                <button
                                    type="button"
                                    className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right"
                                    onClick={this.allocatedmodal.bind(this)}
                                >
                                    Close
                                </button>
                            </div>
                        </ModalFooter>
                    </Modal>

                    <div className="Container-fluid " style={{ opacity: this.state.opacity }}>
                        <div className="row pt-2">
                            <div className="col-10 header pt-2"><b>ALLOCATE INSPECTOR FOR CALL ID : {this.state.callId}</b></div>
                        </div>

                        <div className="row  pt-2 pr-2">
                            <div className="col-md-3">

                                <p className="pt-2"><b>Inspector Type:</b></p>
                            </div>
                            <div className="col-md-3">
                                {(this.props.allinspectorswithtypes.loading == false) ?
                                    <DropdownFlat defaultopt="Select Inspector Type" data={typearray} actions={this.handleType} keyObjName={"id"} selectedValue={this.state.selectedFromTypeDropdown} valueObjName={"name"} />
                                    : null}
                            </div>
                            <div className="col-md-3">
                                <p className="pt-2"><b>Select Inspector:</b></p>
                            </div>
                            <div className="col-md-3 ">
                                <DropdownFlat defaultopt="Select Inspector" defaultValue="Select Inspector" selectedValue={this.state.inspectorID} data={this.state.inspector} actions={this.handleInspector} keyObjName={"inspector_id"} valueObjName={"inspector_name"} />
                            </div>
                        </div>

                        <div className="row  pt-2 pr-2">
                            <div className="col-md-3">

                                <p className="pt-2"><b>Start Date:</b></p>
                            </div>
                            <div className="col-md-3">
                                {(this.props.allinspectorswithtypes.loading == false) ?
                                    <Form.Control type="date" onChange={(e) => { this.handleInspectionStartDate(e) }} id={`inspectionStartDate-datepicker`} name={`inspectionStartDate-datepicker`} placeholder="inspection Start Date" value={this.state.inspectionStartDate} />
                                    : null}
                            </div>
                            <div className="col-md-3">
                                <p className="pt-2"><b>End Date:</b></p>
                            </div>
                            <div className="col-md-3">
                                {(this.props.allinspectorswithtypes.loading == false) ?
                                    <Form.Control type="date" onChange={(e) => { this.handleInspectionEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.inspectionEndDate} />
                                    : null}
                            </div>
                        </div>
                        <div className="row  pt-2 pr-2">
                            <div className="col-md-3">

                                <p className="pt-2"><b>Comments:</b></p>
                            </div>
                            <div className="col-md-3">
                                <textarea className="form-control" value={this.state.comments} onChange={(e) => this.handleChangeComment(e)}>{this.state.comments}</textarea>
                            </div>
                        </div>

                        <div className="border border-dark mt-2 mr-2 pl-2">
                            <div className="row  pl-2 pr-4">
                                <div className="col-md-9 pr-4">
                                    {this.state.inspectionDetailsByCallID.length && this.state.inspectionDetailsByCallID.map((value, index) =>
                                        this.state.selectedCalls.includes(value.CallID) ?
                                            (
                                                <div>
                                                    <div className="row  pl-2 pr-4">
                                                        <div className="col-10 header pt-2"><b>Call ID : {value.CallID}</b></div>
                                                    </div>
                                                    <div className="row  pl-2 pr-4">
                                                        <div className="col pr-4">
                                                            <div className="row headerbar" >
                                                                <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                                                <div className="col pt-2 pb-2 borderheaderbar">PO Line Item</div>
                                                                <div className="col pt-2 pb-2 borderheaderbar">Stage \ Final</div>
                                                                <div className="col pt-2 pb-2 borderheaderbar">Location</div>
                                                                <div className="col pt-2 pb-2 borderheaderbar">Inspection Location</div>
                                                                <div className="col pt-2 pb-2 borderheaderbar ">Requested Date</div>
                                                                <div className="col pt-2 pb-2 borderheaderbar">QTY Offered</div>
                                                            </div>
                                                            {value.lineItems.map((item, index) => {
                                                                return (
                                                                    <div className={item.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} >
                                                                        <div className="col pt-2 pb-2 borderheaderbar">{item.POSAPId}</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">{item.POLineItemSAPCode}</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">{item.CallItemType === 'RW' ? (<b>Rework</b>) : item.CallItemType === 'RV' ? (<b>Revisit</b>) : item.CallItemType === 'RJ' ? (<b>Rejected</b>) : ''} {((item.QATemplateStageId == null || item.QATemplateStageId == 0) ? 'Final' : "Stage")}</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">{item.VendorLocation}</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">{item.Location}</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">{dateFormater(item.VendorProposedDate)}</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">{item.OfferedQuantity + ' ' + item.OrderUnit}</div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>

                                                </div>
                                            ) : null
                                    )}
                                </div>
                                <div className="col-md-3">
                                    <button
                                        type="button"
                                        className="btn2 btn-sms1 rounded-pill mt-2 float-left"
                                        onClick={() => this.toggleCalls()}
                                    >Add More Calls</button>
                                </div>
                            </div>

                            {this.state.callList ? (
                                <div className="row pl-4 pt-2 pr-4">
                                    <div className="col-10 header pt-2"><b>Call List</b></div>
                                    <div>
                                        <div className="row  pl-2 pr-4">
                                            <div className="col">
                                                <div className="row  headerbar ">
                                                    <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar ">

                                                        <input
                                                            type="checkbox" onChange={() => this.handleCheckedAll()} checked={this.state.checkedAll} />
                                                    </div>
                                                    <div className="col pt-2 pb-2 borderheaderbar">Call ID</div>
                                                    <div className="col pt-2 pb-2 borderheaderbar">Vendor</div>
                                                    <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                                    <div className="col pt-2 pb-2 borderheaderbar ">Requested Date</div>
                                                    <div className="col pt-2 pb-2 borderheaderbar">Location</div>
                                                    <div className="col pt-2 pb-2 borderheaderbar">Inspection Location</div>
                                                </div>

                                                {this.state.sameLocationCalls.length && this.state.sameLocationCalls.map((value, Index) => {
                                                    return (
                                                        <div className={Index % 2 == 0 ? 'row border ' : 'row  background '}>
                                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">
                                                                <input
                                                                    type="checkbox" checked={this.state.selectedCalls.includes(value.CallID) ? true : false} onChange={(e) => { this.handleCheck(e, value.CallID) }}
                                                                />
                                                            </div>
                                                            <div className="col pt-2 pb-2 borderheaderbar">{value.CallID}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar">{value.VendorName}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar ">{value.POSAPId}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar">{dateFormater(value.VendorProposedDate)}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.VendorLocation}</div>
                                                            <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.RequestedLocation}</div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : ''}

                            <div className="row pt-2">
                                <div className="col">
                                    <button
                                        type="button"
                                        className="btn2 btn-sms1 rounded-pill mt-2 float-left"
                                        onClick={() => this.allocateinspector()}
                                    >Allocate Inspector</button>
                                </div>
                            </div>
                        </div>
                        {(this.state.calenderui == true && this.props.allinspectorswithtypes.loading == false) ?
                            <div className="pt-2">
                                <div>
                                    <FontAwesomeIcon icon={'long-arrow-alt-left'} className="submission-check-cirle mr-2" size="2x" onClick={() => this.changeMonth(-1)} />
                                    <b>{this.fun_month(this.state.month)}</b>
                                    <FontAwesomeIcon icon={'long-arrow-alt-right'} className="submission-check-cirle ml-2" size="2x" onClick={() => this.changeMonth(1)} />
                                </div>
                                <div className="row pr-4">
                                    <div className="col-7">
                                        <Table className="p-4 table1 text-center">
                                            <thead>
                                                <tr>
                                                    <th>SUN</th>
                                                    <th>MON</th>
                                                    <th>TUE</th>
                                                    <th>WED</th>
                                                    <th>THU</th>
                                                    <th>FRI</th>
                                                    <th>SAT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.props.allinspectorswithtypes.inspectorallocation.length > 0 ? this.props.allinspectorswithtypes.inspectorallocation.map((data) => (
                                                    data.length > 0 ?
                                                        (
                                                            <tr>
                                                                {(data[0].isAllocated == true) ? <td onClick={() => this.allocatedmodal(data[0])} style={{ backgroundColor: 'green', color: 'white' }}>{data[0].day}</td> : data[0].day != '' ? <td>{data[0].day}</td> : <td>{data[0].day}</td>}
                                                                {(data[1].isAllocated == true) ? <td onClick={() => this.allocatedmodal(data[1])} style={{ backgroundColor: 'green', color: 'white' }}>{data[1].day}</td> : data[1].day != '' ? <td >{data[1].day}</td> : <td>{data[1].day}</td>}
                                                                {(data[2].isAllocated == true) ? <td onClick={() => this.allocatedmodal(data[2])} style={{ backgroundColor: 'green', color: 'white' }}>{data[2].day}</td> : data[2].day != '' ? <td >{data[2].day}</td> : <td>{data[2].day}</td>}
                                                                {(data[3].isAllocated == true) ? <td onClick={() => this.allocatedmodal(data[3])} style={{ backgroundColor: 'green', color: 'white' }}>{data[3].day}</td> : data[3].day != '' ? <td >{data[3].day}</td> : <td>{data[3].day}</td>}
                                                                {(data[4].isAllocated == true) ? <td onClick={() => this.allocatedmodal(data[4])} style={{ backgroundColor: 'green', color: 'white' }}>{data[4].day}</td> : data[4].day != '' ? <td >{data[4].day}</td> : <td>{data[4].day}</td>}
                                                                {(data[5].isAllocated == true) ? <td onClick={() => this.allocatedmodal(data[5])} style={{ backgroundColor: 'green', color: 'white' }}>{data[5].day}</td> : data[5].day != '' ? <td>{data[5].day}</td> : <td>{data[5].day}</td>}
                                                                {(data[6].isAllocated == true) ? <td onClick={() => this.allocatedmodal(data[6])} style={{ backgroundColor: 'green', color: 'white' }}>{data[6].day}</td> : data[6].day != '' ? <td>{data[6].day}</td> : <td>{data[6].day}</td>}
                                                            </tr>
                                                        ) : null

                                                )) : null}
                                            </tbody>
                                        </Table>
                                    </div>
                                    {this.state.allocatedDetail ?
                                        this.state.allocatedDetail.map((item, index) => (
                                            <div className="col-5" style={{ display: this.state.allocatedinspectionIndex == index ? 'block' : 'none' }}>
                                                <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Allocated Detail</h4>
                                                <div className="row">
                                                    {index == 0 ? '' :
                                                        <FontAwesomeIcon icon={'long-arrow-alt-left'} className="submission-check-cirle ml-2 float-left" size="2x" onClick={() => this.changeAllocatedInspection(index - 1)} />
                                                    }
                                                    {index == (this.state.allocatedDetail.length - 1) ? '' :
                                                        <FontAwesomeIcon icon={'long-arrow-alt-right'} className="float-right  submission-check-cirle  mr-2" size="2x" onClick={() => this.changeAllocatedInspection(index + 1)} />
                                                    }
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Total Allocation : </b></div>
                                                            <div className="col">{(index + 1)} of {this.state.allocatedDetail.length}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>PO No : </b></div>
                                                            <div className="col">{item.POSAPId}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Item No : </b></div>
                                                            <div className="col">{item.POLineItemSAPCode}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>PO Date : </b></div>
                                                            <div className="col">{dateFormater(item.POCreationDate)}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div className="row">
                                        <div className="col">
                                            <div className="row">
                                                <div className="col"><b>Item Delivery Date : </b></div>
                                                <div className="col">{formatDate(item.PODeliveryDate)}</div>
                                            </div>
                                        </div>
                                    </div> */}

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Supplier Name : </b></div>
                                                            <div className="col">{item.VendorName}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Inspection Call No : </b></div>
                                                            <div className="col">{item.InspectionCallNo}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="row">
                                        <div className="col">
                                            <div className="row">
                                                <div className="col"><b>PO Quantity : </b></div>
                                                <div className="col">{item.POLineItemQuantity + " " + item.OrderUnit}</div>
                                            </div>
                                        </div>
                                    </div> */}

                                                {/* <div className="row">
                                        <div className="col">
                                            <div className="row">
                                                <div className="col"><b>Quantity to Inspect : </b></div>
                                                <div className="col">{item.InspectionQuantity + " " + item.OrderUnit}</div>
                                            </div>
                                        </div>
                                    </div> */}

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Location : </b></div>
                                                            <div className="col">{item.Location}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Proposed Inspection Date : </b></div>
                                                            <div className="col">{dateFormater(item.VendorProposedDate)}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Stage to inspect : </b></div>
                                                            <div className="col">{item.StageName}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col"><b>Item Description : </b></div>
                                                            <div className="col"> {item.POLineItemDescription} </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col "><b>Inspector Name : </b></div>
                                                            <div className="col"> {item.InspectorName}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                            <div className="col "><b>Allocated Inspection Date : </b></div>
                                                            <div className="col">{dateFormater(item.InspectionStartDate) + ' - ' + dateFormater(item.InspectionEndDate)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        : ''}
                                </div>
                            </div>
                            : null}
                    </div>
                </div>
            )
        }
    }
}





const mapStateToProps = (state) => ({ allinspectorswithtypes: state.inspectionReducer })
export default connect(mapStateToProps, { getAllInspectorswithTypes, getInspectorAllocationsByInspectorId, GetInspectorAllocationsByInspectorIdWithRange, getInspectionDetailsByInspectorID, postAssignInspector, getInspectionDetailsByCallID, getCallsWithCallLineItems })(Allocateinspector)
